<h1 *ngIf="!hasData" style="text-align: center;">No hay datos de encuesta</h1>
<div *ngIf="hasData" class="chartjs-container">
    <h1 style="text-align: center;">Encuesta</h1>
    <div id="div1">
        <mat-card style="margin-bottom: 1em;">  
            <h2>{{question1}}</h2>
            <canvas baseChart
                [datasets]="chartData" 
                [labels]="tracks" 
                [options]="chartOptions"
                [plugins]="chartPlugins" 
                [legend]="chartLegend" 
                [chartType]="chartType">
            </canvas>
        </mat-card>
        <mat-card style="margin-bottom: 1em;">
            <h2>{{question3}}</h2>
            <canvas baseChart 
                [datasets]="chartData2" 
                [labels]="tracks" 
                [options]="chartOptions"
                [plugins]="chartPlugins" 
                [legend]="chartLegend" 
                [chartType]="chartType">
            </canvas>
        </mat-card>
    </div>
    <div id="div2">
    <mat-card>
        <h2>{{question2}}</h2>
        <canvas baseChart 
            [datasets]="chartData1" 
            [labels]="tracks" 
            [options]="chartOptions"
            [plugins]="chartPlugins" 
            [legend]="chartLegend" 
            [chartType]="chartType">
        </canvas>
    </mat-card>
    </div> 
</div>

